@use '../../styles/variables' as *;
.runwayContainer {
  display: flex;
  @media screen and (max-width: 600px) {
    // flex-direction: column;
  }
  & > div {
    width: 50%;
    min-height: 100%;
    padding: 2rem;
    @media screen and (max-width: 600px) {
      margin-bottom: 2rem;
      padding-left: 0rem;
    }
    h4 {
      max-width: 76%;
      height: 35px;
      text-align: left;
      @media screen and (max-width: 600px) {
        max-width: 95%;
        height: 7vw;
      }
    }
    span,
    h4 {
      font-weight: normal;
      font-size: 16px;
      display: block;
      @media screen and (max-width: 600px) {
        // margin: auto;
        font-size: 14px;
        // line-height: 1.4em;
        // text-align: center;
      }
    }
    span {
      // font-weight: bold;
      line-height: 1.1em;
      font-size: 2.8rem;
      @media screen and (max-width: 600px) {
        font-size: 1.9rem;
      }
    }
    strong {
      line-height: 1em;
      display: block;
      font-size: 190px;
      font-weight: 700;
      @media screen and (max-width: 600px) {
        font-size: 28vw;
      }
    }
    &.typedYellow {
      padding-left: 0;
      padding-right: 3rem;
      strong,
      span {
        color: $yellow;
      }
    }
  }
}
